export default "__VITE_ASSET__DUP_eNRt__"